module.exports = __webpack_public_path__ + "img/SUPPORT.b44cec1c.svg";